import { GamePart } from "../../../contracts";
// TODO: add BreakAfterSecondOvertime once it is declared by SDAPI
export const BreakGameParts = [
    GamePart.BreakAfterFirstOvertime,
    GamePart.BreakAfterFirstPeriod,
    GamePart.BreakAfterSecondPeriod,
    GamePart.BreakAfterThirdPeriod,
    GamePart.BreakAfterFirstQuarter,
    GamePart.BreakAfterSecondQuarter,
    GamePart.BreakAfterThirdQuarter,
    GamePart.BreakAfterFourthQuarter,
    GamePart.BreakAfterFirstHalf,
    GamePart.BreakAfterFirstInning,
    GamePart.BreakAfterSecondInning,
    GamePart.BreakAfterThirdInning,
    GamePart.BreakAfterFourthInning,
    GamePart.BreakAfterFifthInning,
    GamePart.BreakAfterSixthInning,
    GamePart.BreakAfterSeventhInning,
    GamePart.BreakAfterEighthInning,
    GamePart.BreakAfterNinthInning,
    GamePart.BreakAfterTenthInning,
    GamePart.BreakAfterEleventhInning,
    GamePart.BreakAfterTwelfthInning,
    GamePart.BreakAfterThirteenthInning,
    GamePart.BreakAfterFourteenthInning,
    GamePart.BreakAfterFifteenthInning,
    GamePart.Finished
];
export const parseLiveGameState = (liveGameState) => {
    if (!liveGameState) {
        return {};
    }
    if (liveGameState.gameTime) {
        return Object.assign(Object.assign({}, liveGameState), { gameTime: shouldCalculateGameTime(liveGameState.gamePart) ? Math.ceil(Math.abs(liveGameState.gameTime) * 1000) : undefined });
    }
    return liveGameState;
};
const shouldCalculateGameTime = (gamePart) => {
    if (!gamePart) {
        return true;
    }
    return BreakGameParts.indexOf(gamePart) < 0;
};
//# sourceMappingURL=parseLiveGameState.js.map